<div class="file-chooser">
    <div class="file-name">
        <mat-form-field>
            <input matInput disabled="true" [value]="listForm.controls.file.value.name">
        </mat-form-field>
        <button mat-icon-button *ngIf="!isDefaultFile" (click)="setupEmptyFile()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div>
        <button type="button" color="accent" mat-raised-button (click)="fileInput.click()">
            <mat-icon>attach_file</mat-icon>
            Choose a file
        </button>
        <input hidden type="file" #fileInput (change)="uploadFile($event)" accept=".csv" />
    </div>
</div>
